/**
 * @file OrderAgreementBadge.tsx
 * @description Компактный бейдж заявки «доставка по договорённости»
 * (F30, phase19.15 шаг 4).
 *
 * Один компонент на канбан-карточку и строку реестра: менеджер должен видеть,
 * чего ждёт заявка, не открывая заказ, и видеть это одинаково в обоих списках.
 * Подпись и тон берём из реестра `DELIVERY_AGREEMENT_STATUS_META` — новый
 * статус на сервере не требует правок здесь.
 */

import {
  DELIVERY_AGREEMENT_STATUS_META,
  type DeliveryAgreementStatus,
} from "../../lib/api-delivery-agreement";
import { Badge } from "../ui/badge";

interface Props {
  /** `null`/`undefined` — обычный заказ, бейджа нет. */
  status: DeliveryAgreementStatus | null | undefined;
  className?: string;
}

export function OrderAgreementBadge({ status, className }: Props) {
  if (!status) return null;
  const meta = DELIVERY_AGREEMENT_STATUS_META[status];
  return (
    <Badge
      variant={meta.variant}
      className={[meta.className ?? "", className ?? ""]
        .filter(Boolean)
        .join(" ")}
      title={`Доставка по договорённости: ${meta.title.toLowerCase()}`}
    >
      {meta.badge}
    </Badge>
  );
}
